import React, { useEffect, useState } from 'react';
import { Checkbox, Form, Input, Spin } from 'antd';
import { useSelector } from 'react-redux';
import { GetIBWalletDetailsApi, WithdrawIBCommissionApi, GetibWalletApi } from '../../../../api/request/ib/ibWallet';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import ConfirmationModal from '../../../../components/modals/ConfirmationModal.jsx';
import Pagination from '../../../../components/pagination/Pagination.jsx';
import TableWithSkeleton from '../../../../components/table/TableWithSkeleton.jsx';
import columns from '../../../../columns/ibwallet.jsx';
import moment from 'moment/moment.js';
import Fees from '../../../../assets/common/Fees.jsx';
import Dollar from '../../../../assets/common/Dollar.jsx';
import { WithdrawCommission } from '../../../../assets/common/WithdrawCommission.jsx';
import { AvailableCommision } from '../../../../assets/common/AvailableCommision.jsx';
import { handleApiError } from '../../../../utils/handleApiError.js';
import { useResponsive } from '../../../../hooks/useResponsive.js';
import BalanceCardSM from '../../../user/dashboard/components/BalanceCardSM.jsx';

export default function Withdraw() {
    const { isMobile } = useResponsive();
    const [form] = Form.useForm();
    const { userDetails } = useSelector(state => state.user);
    const [isWalletLoading, setIsWalletLoading] = useState(false);
    const [isWithdrawLoading, setIsWithdrawLoading] = useState(false);
    const [wallet, setWallet] = useState({});
    const [initialValues, setInitialValues] = useState({ amount: '', conditions: false });
    const [withdrawValues, setWithdrawValue] = useState(null);
    const [isOpenWithdrawConfirmationModal, setIsOpenWithdrawConfirmationModal] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecord, setTotalRecord] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [data, setDataall] = useState([]);

    const getWalletDetails = async () => {
        try {
            setIsWalletLoading(true);
            const { data } = await GetIBWalletDetailsApi(userDetails?._id);
            if (data?.success) {
                setWallet(data?.data);
            }
            setIsWalletLoading(false);
        } catch (error) {
            setIsWalletLoading(false);
        }
    }

    useEffect(() => {
        getWalletDetails();
    }, []);



    const withdrawHandler = async () => {
        try {
            setIsWithdrawLoading(true);
            const { data } = await WithdrawIBCommissionApi(withdrawValues);
            if (data?.success) {
                setInitialValues({ amount: '' });
                toast.success(data?.message);
                form.resetFields();
                getWalletDetails();
                setIsOpenWithdrawConfirmationModal(false);
            }
            setIsWithdrawLoading(false);
        } catch (error) {
            handleApiError(error);
            setIsWithdrawLoading(false);
        }
    }

    const handleSubmit = async (values) => {
        const params = {
            amount: Number(values?.amount),
            userId: userDetails?._id,
        };
        setWithdrawValue(params);
        setIsOpenWithdrawConfirmationModal(true);
    }

    useEffect(() => {
        getIbwallet()
    }, [page, pageSize]);

    // const getIbwallet = async () => {
    //     try {
    //         let params = {
    //             PageNumber: page,
    //             PageSize: pageSize,
    //         }
    //         setIsLoading(true);
    //         const { data:res } = await GetibWalletApi(new URLSearchParams(params)?.toString());
    //         if (res?.success) {
    //             setDataall(
    //                 res?.data?.map((item) => {
    //                     return {
    //                         ...item,
    //                         name: `${item?.firstName} ${item?.lastName}`,
    //                         requestDate: item?.transactionDate ? moment(item?.transactionDate).format('DD-MM-YYYY LT') : null,
    //                         amount: `$ ${item?.commissionAmount}`
    //                     };
    //                 })
    //             );
    //             setTotalRecord(res?.totalRecords);
    //         }
    //         setIsLoading(false);
    //     } catch (error) {
    //         setIsLoading(false);
    //     }
    // };

    const getIbwallet = async () => {
        try {
            let params = {
                PageNumber: page,
                PageSize: pageSize,
            }
            setIsLoading(true);
            const { data: res } = await GetibWalletApi(new URLSearchParams(params)?.toString());
            if (res?.success) {
                setDataall(
                    res?.data?.map((item) => {
                        return {
                            ...item,
                            name: `${item?.firstName} ${item?.lastName}`,
                            requestDate: item?.transactionDate ? moment(item?.transactionDate).format('DD-MM-YYYY LT') : null,
                            amount: `$ ${item?.commissionAmount}`
                        };
                    })
                );
                setTotalRecord(res?.totalRecords);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    };


    return (
        <div>
            <div className={isMobile ? 'my-5' : 'border-2 border-light rounded-xl px-4 py-6'}>
                {isWalletLoading ? (
                    <div className="flex justify-center flex-col my-2">
                        <Spin size="large" />
                        <p className="primary text-center mt-2">Loading...</p>
                    </div>
                ) : isMobile ? (
                    <div className="grid grid-cols-2 gap-5">
                        <BalanceCardSM
                            type="Generate Comm..."
                            amount={`$ ${wallet?.generateCommission || 0}`}
                            color="bg-[#7367F010]"
                            gradient="from-[#7367F010] to-[#ffff]"
                            icon={<Fees color="#7367F0" />}
                        />
                        <BalanceCardSM
                            type="Available Comm..."
                            amount={`$ ${wallet?.ibWalletBalance || 0}`}
                            color="bg-[#00727D10]"
                            gradient="from-[#00727D10] to-[#ffff]"
                            icon={<AvailableCommision color="#00727D" />}
                        />
                        <BalanceCardSM
                            type="Withdraw Comm..."
                            amount={`$ ${wallet?.withdrawCommission || 0}`}
                            color="bg-[#00BAD110]"
                            gradient="from-[#00BAD110] to-[#ffff]"
                            icon={<WithdrawCommission color="#00BAD1" />}
                        />
                        {wallet?.isRuleActive && (
                            <>
                                <BalanceCardSM
                                    type="Minimum Transfer"
                                    amount={`$ ${wallet?.minimum || 0}`}
                                    color="bg-[#28C76F10]"
                                    gradient="from-[#28C76F10] to-[#ffff]"
                                    icon={<Dollar color="#28C76F" />}
                                />
                                <BalanceCardSM
                                    type="Maximum Transfer"
                                    amount={`$ ${wallet?.maximum || 0}`}
                                    color="bg-[#FF9F4310]"
                                    gradient="from-[#FF9F4310] to-[#ffff]"
                                    icon={<Dollar color="#FF9F43" />}
                                />
                            </>
                        )}
                    </div>
                ) : (
                    <div className={`grid gap-5 ${wallet?.isRuleActive ? 'sm:grid-cols-3 lg:grid-cols-5' : 'sm:grid-cols-3 lg:grid-cols-3'}`}>
                        <div className='flex items-center gap-3'>
                            <div className="flex justify-center items-center bg-[#E9E7FD] w-[45px] h-[45px] rounded-lg">
                                <Fees color="#7367F0" />
                            </div>
                            <div>
                                <p className='sm:text-xl text-lg'>$ {wallet?.generateCommission || 0}</p>
                                <p className='text-sm font-medium text-gray-500 capitalize'>Generate Commission</p>
                            </div>
                        </div>
                        <div className='flex items-center gap-3'>
                            <div className="flex justify-center items-center bg-[#E5F1F2] w-[45px] h-[45px] rounded-lg">
                                <AvailableCommision color="#00727D" />
                            </div>
                            <div>
                                <p className='sm:text-xl text-lg'>$ {wallet?.ibWalletBalance || 0}</p>
                                <p className='text-sm font-medium text-gray-500 capitalize'>Available Commission</p>
                            </div>
                        </div>
                        <div className='flex items-center gap-3'>
                            <div className="flex justify-center items-center bg-[#D6F4F8] w-[45px] h-[45px] rounded-lg">
                                <WithdrawCommission color="#00BAD1" />
                            </div>
                            <div>
                                <p className='sm:text-xl text-lg'>$ {wallet?.withdrawCommission || 0}</p>
                                <p className='text-sm font-medium text-gray-500 capitalize'>Withdraw Commission</p>
                            </div>
                        </div>
                        {wallet?.isRuleActive && (
                            <>
                                <div className='flex items-center gap-3'>
                                    <div className="flex justify-center items-center bg-[#DDF6E8] w-[45px] h-[45px] rounded-lg">
                                        <Dollar color="#28C76F" />
                                    </div>
                                    <div>
                                        <p className='sm:text-xl text-lg'>$ {wallet?.minimum || 0}</p>
                                        <p className='text-sm font-medium text-gray-500 capitalize'>Minimum Transfer</p>
                                    </div>
                                </div>
                                <div className='flex items-center gap-3'>
                                    <div className="flex justify-center items-center bg-[#FFF0E1] w-[45px] h-[45px] rounded-lg">
                                        <Dollar color="#FF9F43" />
                                    </div>
                                    <div>
                                        <p className='sm:text-xl text-lg'>$ {wallet?.maximum || 0}</p>
                                        <p className='text-sm font-medium text-gray-500 capitalize'>Maximum Transfer</p>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                )}
            </div>

            <div className="border-[2px] border-light rounded-xl pt-4 lg:pt-6 w-full mt-5">
                <p className="text-[#2F2B3D] text-xl font-semibold px-4 lg:px-6 pb-4 border-b border-light">Withdraw</p>

                <Form className='w-full' autoComplete="off" form={form} initialValues={initialValues} onFinish={handleSubmit}>
                    <div className='p-4'>
                        <div className="md:w-1/3">
                            <label className='text-lg text-[#2F2B3DCC] font-medium'>Amount In USD</label>
                            <Form.Item
                                name='amount'
                                rules={[
                                    { required: true, message: 'Please enter amount.' },
                                    {
                                        validator: (_, value) => {
                                            if (!value) {
                                                return Promise.resolve();
                                            }
                                            const amount = Number(value);
                                            if (!Number.isInteger(amount)) {
                                                return Promise.reject(new Error('Please enter a valid amount.'));
                                            }
                                            if (wallet?.isRuleActive) {
                                                if (amount < wallet?.minimum) {
                                                    return Promise.reject(new Error(`Amount must be at least $${wallet?.minimum}.`));
                                                }
                                                if (amount > wallet?.maximum) {
                                                    return Promise.reject(new Error(`Amount cannot exceed $${wallet?.maximum}.`));
                                                }
                                            }
                                            return Promise.resolve();
                                        },
                                    },
                                ]}
                            >
                                <Input type='number' placeholder="Amount in USD" className="mt-1 w-full ps-4 py-2" />
                            </Form.Item>
                        </div>

                        <div className='flex flex-wrap justify-between items-center'>
                            <Form.Item name='conditions' valuePropName="checked" rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions.')), }]} >
                                <Checkbox className='mt-4'>Yes, I agreed to the <Link to={'/terms_&_conditions'} className='primary hover:underline duration-300' >Terms and conditions</Link></Checkbox>
                            </Form.Item>
                            <div className="mt-4">
                                <button type='submit' className='bg-primary text-sm text-white font-semibold rounded-lg px-8 py-2 uppercase themeHover duration-500'>Submit</button>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>

            {/* Withdraw confirmation modal */}
            <ConfirmationModal
                isOpen={isOpenWithdrawConfirmationModal}
                setIsOpen={setIsOpenWithdrawConfirmationModal}
                type="success"
                message="Are you sure you want to proceed this withdraw request?"
                onConfirm={withdrawHandler}
                isLoading={isWithdrawLoading}
                loadingLabel="Adding request..."
            />

            <div className='py-6'>
                <div className="border border-gray-200 rounded-xl">
                    <TableWithSkeleton columns={columns} data={data} loading={isLoading} />
                </div>
                <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
            </div>
        </div>
    )
}